import React from 'react';
import { Surgerie } from 'types/surgerie';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import RowActionButton from 'components/data-grid/RowActionButton';
import { surgerieOpenTableTemplate } from '../../template/surgerieOpenTableTemplate';
import SurgerieMenu from '../menu/SurgerieMenu';
import { useSurgerie } from '../../hooks/useSurgerie';

type SurgerieListTableProps = {
  surgeries: Surgerie[];
};

const SurgerieListTable: React.FC<SurgerieListTableProps> = ({ surgeries }) => {
  const { anchorEl, setAnchorEl, setSelectedSurgerie } = useSurgerie();

  return (
    <>
      {anchorEl && <SurgerieMenu anchorEl={anchorEl} />}

      <DataGridList
        template={surgerieOpenTableTemplate}
        rows={surgeries}
        getRowId={row => row.id_int}
        renderCells={{
          action: surgerie => (
            <RowActionButton
              onOpen={anchor => {
                setAnchorEl(anchor);
                setSelectedSurgerie(surgerie);
              }}
            />
          ),
        }}
        onRowClick={row => history.push(`/surgeries/${row.id_int}`)}
        fileName="cirurgias_abertas"
        sheetName="Cirurgias abertas"
      />
    </>
  );
};

export default SurgerieListTable;
